import React, { FC } from 'react';
import { Dialog } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import API from 'api/API';
import { useLanguage } from 'context/AppContext';
import * as Styles from '../SetModal.styles';

interface EditDraftModalProps {
  open: boolean;
  close: () => void;
  url: string;
  titleText: string;
  bodyText: string;
  type: 'SET' | 'DEVICE';
  setCode?: string;
}

const EditDraftModal: FC<EditDraftModalProps> = ({ open, close, url, titleText, bodyText, type, setCode }) => {
  const [language] = useLanguage();
  const navigate = useNavigate();

  const handleCreate = async (): Promise<void> => {
    try {
      switch (type) {
        case 'SET':
          if (!setCode) {
            toast.error(`Failed to load set ${setCode}`);
            break;
          }

          await API.set.load(setCode);
          navigate(url);
          break;
        case 'DEVICE':
          navigate(url);
          break;
      }
    } catch (error) {
      API.errorHandler(error);
    }
  };

  return (
    <Dialog open={open} onClose={close} maxWidth={'md'} fullWidth={false}>
      <Styles.SetModalCenteredContainer>
        <Styles.SetModalHeader>{titleText}</Styles.SetModalHeader>
        <p>{bodyText}</p>
        <Styles.SetModalSpacedButtonContainer>
          <Styles.SetModalEditCancelButton onClick={close}>
            {language.EditDraftModal.decline}
          </Styles.SetModalEditCancelButton>
          <Styles.SetModalEditConfirmButton onClick={handleCreate}>
            {language.EditDraftModal.confirm}
          </Styles.SetModalEditConfirmButton>
        </Styles.SetModalSpacedButtonContainer>
      </Styles.SetModalCenteredContainer>
    </Dialog>
  );
};

export default EditDraftModal;
